import { useTranslation } from 'react-i18next';
import DefaultLayout from 'src/components/layouts/DefaultLayout';
import { UsersCRUD } from 'src/components/PropertyManager/Users';

const EmployeesPage = () => {
  const { t } = useTranslation('admin', { keyPrefix: 'property.users' });

  return (
    <DefaultLayout title={t('employees')}>
      <UsersCRUD userType={'EPE'} />
    </DefaultLayout>
  );
};

export default EmployeesPage;
